
import axios from 'axios';


export function extractToken () {
  const listCookies = window.document.cookie.split(';');
  for (let c of listCookies) {
    c = c.trim().split('=');
    if (c[0] === 'api_token') {
      return c[1];
    }
  }
  return '';
}


// axios.defaults.baseURL = process.env.REACT_APP_DELEEVAPI;
// axios.defaults.headers.common['Authorization'] = 'Token ' + extractToken();
// axios.defaults.headers.common['Content-Type'] = 'application/json';

export const da = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_DELEEVAPI,
  timeout: 30000,
  headers: {
    'Authorization': 'Token ' + extractToken(),
    'Content-Type': 'application/json'
  }
});


// UTILS


let daUtil = {};

daUtil.req = function (method, url, data, config = {}) {
  return da.request({
    method: method,
    url: url,
    data: data,
    ...config
  }).then(response => response.data)
    .catch(err => {
      throw err;
    });
};

daUtil.post = function (url, data, config = {}) {
  return daUtil.req('post', url, data, config);
};

daUtil.patch = function (url, data, config = {}) {
  return daUtil.req('patch', url, data, config);
};

daUtil.get = function (url, config = {}) {
  return daUtil.req('get', url, null, config);
};

// metier


let api = {};


api.autoRefresh = function (version, centerId) {
  return da.get('/tasks/state/?version=' + version + '&center_id=' + centerId)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};


api.loadShippingTasks = function (taskIds) {
  if (taskIds.length <= 0) {
    return [];
  }
  let taskIdsSerialized = taskIds.join();
  return da.get('/tasks/shipping/?ids=' + taskIdsSerialized + '&compact=1')
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};


api.saveShippingTasks = function (tasks, format) {
  //da.post('/tasks/shipping/simple_bulk/', tasks);
  let url = "/tasks/shipping/simple_bulk/";
  if (format === "dispatch") {
    url += "?dispatch=1";
  }
  return da.request({
    method: "post",
    url: url,
    data: tasks
  }).then(response => response.data)
    .catch(err => {
      throw err;
    });
};


api.shippingTaskToXdDock = taskId => {
  return da.get(`/tasks/shipping/${taskId}/assign_xd_dock/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};


api.savePackingTasks = function (tasks) {
  return da.post('/tasks/packing/simple_bulk/', tasks)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};


api.changeOrderStatus = function (
  orderId,
  status,
  serializer_type,
  additionalData,
) {
  // serializer_type = simple ou flat
  if (!serializer_type) {
    serializer_type = "simple";
  }
  let data = {
    "status": status,
    ...additionalData,
  };
  data[serializer_type] = true;
  return da.post(`/processing-orders/${orderId}/change_status/`, data)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.bulkChangeOrderStatus = (payload) => {
  return da.post(`/processing-orders/bulk_change_status/`, payload)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.destockAgain = function (orderId) {
  return da.post(`/orders/${orderId}/destock/`, {})
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};



api.editOrder = function (order) {
  order.flat = 1;
  return da.patch(`/processing-orders/${order.id}/`, order)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.processingOrder = function (service, data) {
  return da.post(`/processing-orders/${data.id}/${service}/`, data)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.getLateSmsContent = (orderId, smsTemplateId, creditsAmount) => {
  return da.get(`/processing-orders/${orderId}/late_sms_content/?sms_template_id=${smsTemplateId}&credits_amount=${creditsAmount}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.ignoreLateOrder = orderId => {
  return da.get(`/processing-orders/${orderId}/process_late_order/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.validateLateOrder = (orderId, data) => {
  return da.post(`/processing-orders/${orderId}/process_late_order/`, data)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.addOrderCrate = (orderId, crateCode, flat = null) => (
  da.post(`/processing-orders/${orderId}/add_crate/?ser=admin`, { crate_code: crateCode, flat })
    .then(response => response.data)
    .catch(err => {
      throw err;
    })
);

api.deleteOrderCrate = (orderId, crateCode, flat = null) => (
  da.post(`/processing-orders/${orderId}/delete_crate/?ser=admin`, { crate_code: crateCode, flat })
    .then(response => response.data)
    .catch(err => {
      throw err;
    })
);

api.loadDock = function (dock_id) {
  return da.get(`/docks/${dock_id}/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.editDock = function (dock) {
  return da.patch(`/docks/${dock.id}/`, dock)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.closeDock = function (dock) {
  return da.delete(`/docks/${dock.id}/`, dock).then(r => r.data).catch((err) => { throw err; });
};

api.createStuartJob = function (dock, transportType) {
  throw Error('Non prevu pour le multi centre');
  /*
  return da.post(`/docks/${dock.id}/external_jobs/`, {"transport_type": transportType})
    .then(response => response.data)
    .catch(error => console.error(error));
  //*/
};

api.cancelStuartJob = function (dock) {
  return da.delete(`/docks/${dock.id}/external_jobs/`).then(r => r.data).catch(err => { throw err; });
};

api.getStuartJob = jobId => (
  da.get(`/processing-orders/get_external_job/?job_id=${jobId}`).then(r => r.data).catch(err => { throw err; })
);

api.getStuartEta = (orderId, vehicle) => (
  da.get(`/processing-orders/${orderId}/get_stuart_eta_to_center/?vehicle=${vehicle}`)
    .then(r => r.data)
    .catch(err => { throw err; })
);

api.callStuartForDock = (dockId, vehicle) => (
  da.post(`/dispatch/docks/${dockId}/call_stuart/`, { vehicle })
    .then(r => r.data)
    .catch(err => { throw err; })
);

api.callStuartForOrder = (orderId, vehicle) => (
  da.get(`/processing-orders/${orderId}/call_stuart/?vehicle=${vehicle}&flat=1`)
    .then(r => r.data)
    .catch(err => { throw err; })
);

api.callUberForOrder = (orderId) => (
  da.post(`/processing-orders/${orderId}/call_uber_direct/?flat=1`)
    .then(r => r.data)
    .catch(err => { throw err; })
);

api.cancelUberJob = function (dock) {
  return da.post(`/dispatch/docks/${dock.id}/cancel_uber_delivery/`).then(r => r.data).catch(err => { throw err; });
};

api.regularizeCanceledUber = dock => {
  return da.post(`/dispatch/docks/${dock.id}/regularize_canceled_uber/`)
    .then(response => response.data)
    .catch(error => console.error(error));
};

api.regularizeCanceledStuart = dock => {
  return da.post(`/docks/${dock.id}/regularize_canceled_stuart/`)
    .then(response => response.data)
    .catch(error => console.error(error));
};

api.getUberDirectWindows = dockId => (
  da.get(`/dispatch/docks/${dockId}/available-uberdirect-windows/`)
    .then(r => r.data)
    .catch(err => { throw err; })
);

api.createUberDirectBatch = (dockId, dropoffReady, dropoffDeadline) => (
  da.post(`/dispatch/docks/${dockId}/to-uberdirect-batch/`, {
    dropoff_ready: dropoffReady,
    dropoff_deadline: dropoffDeadline,
  })
    .then(r => r.data)
    .catch(err => { throw err; })
);

api.cancelUberDirectBatch = (dockId) => (
  da.post(`/dispatch/docks/${dockId}/cancel-uberdirect-waiting-batch/`)
    .then(r => r.data)
    .catch(err => { throw err; })
);

// do not cleanup the task, but force all task in received
api.finishDock = function (dock) {
  return da.post(`/docks/${dock.id}/finish/`).then(r => r.data).catch(err => { throw err; });
};

api.dockManuallyOptimized = function (dock) {
  return (
    da
      .post(`/docks/${dock.id}/manually_optimized/`)
      .then(r => r.data)
      .catch(err => { throw err; })
  );
};

api.dockManuallyValidated = function (dock) {
  return (
    da
      .post(`/docks/${dock.id}/manually_validated/`)
      .then(r => r.data)
      .catch(err => { throw err; })
  );
};

api.xdLoadedDock = (dockId) => (
  da.post(`/docks/${dockId}/xd_loaded/`).then(r => r.data).catch(err => { throw err; })
);

api.startPresence = function (driverId, vehicle, centerId) {
  const d = {
    vehicle: vehicle,
    center_id: centerId,
    caller: "flow",
  };
  return da.post(`/drivers/${driverId}/start/`, d).then(r => r.data).catch(err => { throw err; });
};

api.stopPresence = function (driverId, unfinished_new_status) {
  return da.post(`/drivers/${driverId}/stop/?unfinished_new_status=${unfinished_new_status}`, {})
    .then(r => r.data).catch(err => { throw err; });
};

api.processDriverReturn = function (driverId) {
  return da.post(`/drivers/${driverId}/process_return/`, {})
    .then(r => r.data).catch(err => { throw err; });
};

api.changeVehicle = function (driverId, vehicle) {
  return daUtil.post(`/drivers/${driverId}/vehicle/`, { vehicle: vehicle });
};

api.changeCenter = function (driverId, centerId) {
  return daUtil.post(`/drivers/${driverId}/change_center/`, { center_id: centerId });
};

api.getHiddenProductsToReturn = driverId =>
  daUtil.get(`/drivers/${driverId}/hidden_product_to_return`);

api.closeAlert = function (alert) {
  return daUtil.patch(`/alerts/${alert.id}/`, { is_read: true });
};

api.loadArrivals = function (centerId) {
  return da.get(`/arrivals/?center=${centerId}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.validateArrivals = function (arrivals) {
  return da.post(`/arrivals/`, { arrivals })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.loadDispatch = function (version, centerId, additionalParameters) {
  return da.get(`/dispatch/loadstate/?version=${version}&center_id=${centerId}${additionalParameters}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// Projection « dry-run » (lecture seule) : ce que notre lib de construction de docks produirait
// pour ce centre. `options` = flags des passes d'optimisation (seine_crossing, express_insertion,
// consolidation, repair, max_wait_min). Ne persiste rien côté serveur.
api.projectDocks = function (centerId, options = {}) {
  return da.get(`/dispatch/projection/project/`, { params: { center_id: centerId, ...options } })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// Dry-run de comparaison : renvoie côte à côte le découpage réel du dispatcher (prod) et le
// découpage de notre lib, pour comparer les remplissages. Lecture seule, ne persiste rien.
api.compareDocks = function (centerId, options = {}) {
  return da.get(`/dispatch/projection/compare/`, { params: { center_id: centerId, ...options } })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// Lance le comparatif en tâche de fond (le calcul dépasse le timeout web) : renvoie { job_id }
// à sonder via compareStatus. Mêmes paramètres que compareDocks (dont { snapshot }).
api.compareStart = function (centerId, options = {}) {
  return da.get(`/dispatch/projection/compare_start/`, { params: { center_id: centerId, ...options } })
    .then(response => response.data);
};

// Statut d'un job de comparaison : { status, progress, result? } — result = payload complet à la fin.
api.compareStatus = function (jobId) {
  return da.get(`/dispatch/projection/compare_status/`, { params: { job_id: jobId } })
    .then(response => response.data);
};

// UN tick d'un live OBSERVÉ à l'instant présent, sans écriture ni rejeu du passé : gèle ce qui doit
// partir, glisse les préparées dans les tournées déjà gelées, relève le découpage réel du dispatcheur.
// Cycle complet + côté réel = 60-90 s sur un vrai pool → tâche de fond : `liveTickStart` renvoie
// {job_id}, à sonder via `liveTickStatus` ({ status, result? }). L'écran reporte `open`/`next_uid`
// et `gone_order_ids` au tick suivant.
api.liveTickStart = function (centerId, { source, options, stepMin, seedsState, nextUid, goneOrderIds } = {}) {
  return da.post(`/dispatch/projection/live_tick_start/`, {
    center_id: centerId, source, options,
    step_min: stepMin, seeds_state: seedsState || [], next_uid: nextUid || 0,
    gone_order_ids: goneOrderIds || [],  // commandes des tournées parties (gardées par l'écran) : exclues du pool
  }).then(response => response.data);
};

api.liveTickStatus = function (jobId) {
  return da.get(`/dispatch/projection/live_tick_status/`, { params: { job_id: jobId } })
    .then(response => response.data);
};

// Ids des snapshots récents d'un centre (vues figées rejouables via compareDocks({ snapshot })).
api.listSnapshots = function (centerId, day = "") {
  return da.get(`/dispatch/projection/snapshots/`, { params: { center_id: centerId, day } })
    .then(response => (response.data && response.data.snapshots) || [])
    .catch(() => []);
};

// Simulations de dispatch d'un centre (rejeu d'une journée par la lib, comparé au réel). Liste des
// simulations (résumé + comparatif simulé vs réel), la plus récente d'abord.
api.listSimulations = function (centerId) {
  return da.get(`/dispatch/projection/simulations/`, { params: { center_id: centerId } })
    .then(response => (response.data && response.data.simulations) || [])
    .catch(() => []);
};

// Détail d'une simulation : ses tournées figées + le comparatif simulé vs réel.
api.getSimulation = function (id) {
  return da.get(`/dispatch/projection/simulation/`, { params: { id } })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// Crée une simulation (centre, jour YYYY-MM-DD, pas en minutes). Réponse :
//   { status: "exists", id }  → la sim existait déjà (à sélectionner directement) ;
//   { status: "queued", … }   → génération lancée en tâche de fond (~10 min), sonder listSimulations.
api.createSimulation = function (centerId, day, step, tol = {}, overwrite = false) {
  return da.post(`/dispatch/projection/simulate/`, { center_id: centerId, day, step, ...tol, overwrite })
    .then(response => response.data);
};

// Progression (0-100) + statut RQ d'un job de génération de simulation. {status, progress, simulation_id}.
api.simulationStatus = function (jobId) {
  return da.get(`/dispatch/projection/simulation_status/`, { params: { job_id: jobId } })
    .then(response => response.data);
};

// Métriques ISO (temps/coût/retard/avance) par Dock réel du dispatcheur, pour l'écran /dispatch.
// Renvoie {docks: {dock_id: {...}}, totals: {...}}. Lecture seule.
api.dockEstimates = function (centerId, options = {}) {
  return da.get(`/dispatch/projection/estimates/`, { params: { center_id: centerId, ...options } })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.loadSlotsForOrder = function (postalCode, orderId) {
  return da.get(`/postal_codes/slots/?postal_code=${postalCode}&order_id=${orderId}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.getUserAddresses = function (userId) {
  return da.get(`/admin-addresses/?user_id=${userId}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.bulkUpdateBillingAddress = function (payload) {
  return da.patch(`/processing-orders/bulk_update_billing_address/`, payload)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.resetOrderForRedelivery = function (orderId, data) {
  return da.post(`/processing-orders/${orderId}/reset_for_redelivery/`, { ...data })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.orderToRestock = function (orderId, flagId = 1) {
  return da.get(`/processing-orders/${orderId}/to_restock/?flag_id=${flagId}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.validateRestock = function (orderId) {
  return da.get(`/processing-orders/${orderId}/validate_restock/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.getLastDriver = function (orderId) {
  return da.get(`/processing-orders/${orderId}/get_last_driver/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.orderWasDelivered = function (orderId) {
  return da.post(`/processing-orders/${orderId}/was_delivered/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.orderDirectDispatch = (orderId) => {
  return da.post(`/processing-orders/${orderId}/direct_dispatch/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.ordersDirectDispatch = (orderIds, define) => {
  return da.post(
    `/docks/direct_dispatch_many/?order_ids=${orderIds.join(",")}&define=${define ? "1" : "0"}`
  )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.listAllUberOrders = (centerId = null) => {
  return da.get(`/uber-eats/all-orders/?center_id=${centerId}&version=2`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.retrieveUberEatsStoreStatus = (centerId) => {
  return da.get(`/uber-eats/stores/${centerId}/status/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.updateUberEatsStoreStatus = (centerId, storeId, status) => {
  return da.put(`/uber-eats/stores/${centerId}/status/`, { store_id: storeId, status })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.listUberEatsStoreStatusChangeLogs = (storeId) => {
  return da.get(`/uber-eats/stores/status-logs/`, { params: { store_id: storeId } })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.retrieveDeliverooSiteStatus = (centerId) => {
  return da.get(`/deliveroo/sites/${centerId}/status/`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.updateDeliverooSiteStatus = (centerId, siteId, status) => {
  return da.put(`/deliveroo/sites/${centerId}/status/`, { site_id: siteId, status })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.listDeliverooSiteStatusChangeLogs = (siteId) => {
  return da.get(`/deliveroo/sites/status-logs/`, { params: { site_id: siteId } })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.listAllDeliverooOrders = (centerId = null) => {
  return da.get(`/deliveroo/all-orders/?center_id=${centerId}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// api.setCenterDQPIsEnabled = (centerId, payload) => {
//   return da.post(`/centers/${centerId}/dqp-is-enabled`, payload)
//     .then(response => response.data)
//     .catch(err => {
//       throw err;
//     });
// };

// Dispatch auto : bascule depuis l'écran /dispatch (permission dédiée côté API).
// payload = { enabled?: bool, first_enabled?: bool } ; renvoie l'état des deux interrupteurs.
api.setDispatchAuto = (centerId, payload) => (
  da.post(`/centers/${centerId}/dispatch-auto/`, payload).then(r => r.data)
);

api.setCenterSiteDQPIsEnabled = (centerId, siteId, payload) => {
  return da.post(`/centers/${centerId}/dqp-is-enabled/`, {
    site_id: siteId,
    ...payload,
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// api.updateCenterSiteDQPDelays = (centerId, payload) => {
//   return da.post(`/centers/${centerId}/dqp-delays/`, payload)
//     .then(response => response.data)
//     .catch(err => {
//       throw err;
//     });
// };

api.updateCenterSiteDQPDelays = (centerId, siteId, payload) => {
  return da.post(`/centers/${centerId}/dqp-delays/`, {
    site_id: siteId,
    ...payload,
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.getPackerComments = (userId) => {
  return daUtil.get(`/packer-comment/about/?user=${userId}`);
};

api.createPackerComment = (aboutUserId, comment, numberOfWorkedDaysForNext = 0) => {
  // next_status_id = NEED_ALERT_LATER (2) si on planifie un point ; sinon NOT_CONCERNED (1)
  const nextStatusId = numberOfWorkedDaysForNext > 0 ? 2 : 1;
  return daUtil.post('/packer-comment/', {
    comment,
    number_of_worked_days_for_next: numberOfWorkedDaysForNext,
    next_status_id: nextStatusId,
    about_user: aboutUserId,
  });
};

api.uberCancelResolve = (task, deliveryId) => {
  // Get order_id from task.linked_order
  const orderId = task.linked_order && task.linked_order.id;
  if (!orderId) {
    return Promise.reject(new Error('Task has no linked_order'));
  }
  const body = {};
  if (deliveryId) {
    body.delivery_id = deliveryId;
  }
  return da.post(`/processing-orders/${orderId}/uber-batch-resolve/`, body)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

api.createPaymentLink = (orderId, amount) => {
  return daUtil.post('/admin-checkout/payment-link', {
    order_id: orderId,
    amount: amount,
  });
};

// Envoie par email au client de la commande le lien de paiement Checkout `url`
// (renvoyé par createPaymentLink). `amount` en euros (string 2 décimales),
// optionnel : s'il est absent le mail parle du "montant restant dû".
api.sendPaymentLinkEmail = (orderId, url, amount) => {
  return daUtil.post('/admin-checkout/payment-link/send', {
    order_id: orderId,
    url: url,
    ...(amount ? { amount } : {}),
  });
};


// Commandes en attente de produits d'un centre, dans l'ordre où les préparateurs
// les recevront (même règle que la file : rang du dispatch, puis heure de départ).
api.getWaitingProducts = (centerId) => {
  return daUtil.get(`/tasks/waiting-products/?center_id=${centerId}`);
};

// Mode passage des recherches de manquants (chef d'équipe) : les préparateurs
// peuvent passer à la commande suivante, la commande passée reste dans la file.
api.getMissingSkipMode = (centerId) => {
  return daUtil.get(`/tasks/missing-skip-mode/?center_id=${centerId}`);
};

// Priorité d'une attente : 0 aucune, 1 élevée, 2 urgente ; renvoie la liste du jour
api.setWaitingPriority = (centerId, taskId, priority, day) => {
  const params = day ? { center_id: centerId, day: day } : { center_id: centerId };
  return daUtil.post('/tasks/waiting-products/', { task_id: taskId, priority: priority }, { params: params });
};

api.setWaitingPriorityByOrder = (centerId, orderId, priority) => {
  return daUtil.post('/tasks/waiting-products/', { order_id: orderId, priority: priority }, { params: { center_id: centerId } });
};

api.setMissingSkipMode = (centerId, active) => {
  return daUtil.post('/tasks/missing-skip-mode/', { active: active }, { params: { center_id: centerId } });
};

export { api, daUtil };
